import swal from 'sweetalert2';

export const funnelMixin = {
  data() {
    return {
      funnelFailed: false,
    };
  },
  methods: {
    goToNextFunnelStep(args) {
      const vm = this;
      if (vm.funnel) {
        const url = vm.$apiService.funnelsUrl();
        const data = {
          current_path: window.location.pathname,
        };
        if (args) {
          data.args = args;
        } else {
          data.args = { };
        }
        // This is a hack. See wizard.html.erb and shortcut story 289
        // Basically, we always render the user verify based on funnel state server side
        // so they can't get to this funnel step firing unless they did that.
        data.args.user_identity_verified = true;

        axios.put(url, data)
          .then((response) => {
            // A completed funnel can return an explicit destination (e.g. coach lesson
            // link signups hand off to the coach's availability page)
            const { state, redirect_url: redirectUrl } = response.data;
            window.location.assign(redirectUrl || vm.urlForState(state));
          })
          .catch((error) => {
            vm.saving = false;
            vm.funnelFailed = true;
            vm.errorMessage = `Error going to the next step: ${error.toString()}`;
            vm.error = true;

            if (error.response?.status === 404) {
              this.handleNotFound();
            }
          });
      }
    },
    editFunnelStep(targetState, opts = {}) {
      const vm = this;
      if (!vm.funnel) return;

      const payload = { target_state: targetState };
      if (opts.wrestlerId) {
        payload.wrestler_id = opts.wrestlerId;
      }

      const url = vm.$apiService.funnelEditStepUrl();
      axios.put(url, payload)
        .then(() => {
          window.location.assign(vm.urlForState(targetState));
        })
        .catch((error) => {
          vm.funnelFailed = true;
          vm.errorMessage = `Error opening that step for edit: ${error.toString()}`;
          vm.error = true;
          if (error.response?.status === 404) {
            vm.handleNotFound();
          }
        });
    },
    // Exiting destroys the funnel, so it's a POST — link scanners follow GET links
    exitRegistration() {
      const form = document.createElement('form');
      form.method = 'post';
      form.action = '/cookie/exit_registration';
      const token = document.querySelector('meta[name="csrf-token"]')?.content;
      if (token) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'authenticity_token';
        input.value = token;
        form.appendChild(input);
      }
      document.body.appendChild(form);
      form.submit();
    },
    handleNotFound() {
      swal.fire({
        icon: 'error',
        title: 'Your cart was cleared',
        html: '<p>This typically happens if registration closed before you complete sign up or if you completed/exited the registration on a different device or browser.</p><p>If you need assistance please email support@wrestlingiq.com</p>',
        confirmButtonText: 'Ok',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn btn-default',
        },
      })
        .then((result) => {
          window.location.assign('/calendar');
        });
    },
    urlForState(state) {
      switch (state) {
        case 'personal_info':
          return '/required-info';
        case 'add_wrestlers':
          return '/new-wrestler-wizard';
        case 'wrestler_info':
          return '/required-wrestler-info';
        case 'agreements':
          return '/agreements';
        case 'registration':
          return '/memberships/new';
        case 'trial_scheduling':
          return '/trials/schedule';
        default:
          return '/calendar';
      }
    },
  },
};
